var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13 0.2 10.5 1.1 8.60002 2.4C6.50002 1.4 4.00002 1.8 2.30002 3.6C2.00002 3.9 1.70002 4.3 1.40002 4.7L3.90002 7.2C3.20002 8.4 2.80002 9.2 2.80002 9.2L6.90002 13.3C6.90002 13.3 7.70002 13 8.90002 12.2L11.4 14.7C11.8 14.5 12.2 14.2 12.5 13.8C14.2 12.1 14.6 9.5 13.7 7.4C14.9 5.4 15.8 3 16 0Z",
    fill: "#F58562"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.600005 12.6C1.40001 11.8 2.60001 11.8 3.40001 12.6C4.20001 13.4 4.20001 14.6 3.40001 15.4C2.60001 16.2 5.42216e-06 16 5.42216e-06 16C5.42216e-06 16 -0.199995 13.3 0.600005 12.6Z",
    fill: "#F58562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketOrange);
export default __webpack_public_path__ + "static/media/rocket_orange.a0ade2d76c50a626435d21614db6bc1e.svg";
export { ForwardRef as ReactComponent };